import { List } from 'immutable';
import React from 'react';
import { Fun, mk_widget, nothing, Option, Pair } from 'widgets-for-react';
import { ContentType } from '../../public_site.main.mod';
import { Breadcrumb } from '../../wordpress/types_and_parser/extra_types.mod';
import { ParsedNode } from '../../wordpress/types_and_parser/types.mod';
import { ExtraImages } from '../utils/extra_images.mod';
import { pageFooter, PageFooterProps } from './page_footer.mod';
import { pageHeader, PageHeaderProps } from './page_header.mod';

export type PageHeaderFooterProps<ExtraImages> = {
  header: PageHeaderProps<ExtraImages>
  footer: PageFooterProps<ExtraImages>
}

export const page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, Fun<PageHeaderFooterProps<ExtraImages>, ContentType>> = page => headerFooterProps => blocks => (
  page.snd.v.kind == 'l' 
    ? nothing() 
    : mk_widget({
      run: o => (
        <main id="a11y-main" className={`main main--default`}>
          {pageHeader(page.fst)(headerFooterProps.header).run(() => null)}
          
          <div className={`page page--default`}>
            {blocks.run(o)}
          </div>

          {pageFooter(page.fst)(headerFooterProps.footer).run(() => null)}
        </main>
      )
    })
)